import React from "react";
import styled from "styled-components";
import Logo from "../../SVGs/LogoGrey.png";

function NothingToShow(props) {
  return (
    <Container background={props.background}>
      {props.text}
      {/* <img src={Logo} height="200px" /> */}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  backgorund-color: #d4eef0;
  flex-direction: column;
  width: 100%;
  gap: 20px;

  min-height: 60vh;

  border-radius: 10px;

  background-color: ${(props) =>
    props.background ? props.background : "white"};

  color: #5e86a5;
  text-align: center;
  font-family: "Museo Sans Cyrl";
  font-size: 24px;
  font-style: normal;
  font-weight: 300;
  line-height: 90%; /* 21.6px */
  letter-spacing: -0.48px;
`;

export default NothingToShow;
